import { Injectable } from '@angular/core';
import {
  OCC_CART_ID_CURRENT,
  OCC_USER_ID_ANONYMOUS,
  UserIdService,
  WindowRef,
} from '@spartacus/core';
import {
  withLatestFrom,
} from 'rxjs/operators';
import {
  ActiveCartService,
  getCartIdByUserId,
} from "@spartacus/cart/base/core";
import { GonvarriMultiCartService } from './gonvarri-multi-cart.service';
import { Observable, of } from 'rxjs';
import { GonvarriCartEntryAdapter } from '../adapters/gonvarri-cart-entry.adapter';
import { CartModification } from '@spartacus/cart/base/root';

@Injectable({
  providedIn: 'root'
})
export class GonvarriActiveCartService extends ActiveCartService {

  constructor(
    override multiCartFacade: GonvarriMultiCartService,
    userIdService: UserIdService,
    winRef: WindowRef,
    private cartEntryAdapter: GonvarriCartEntryAdapter
  ) {
    super(multiCartFacade, userIdService, winRef);
  }

   public override load(cartId: string, userId: string): void {
    if (!(userId === OCC_USER_ID_ANONYMOUS && cartId === OCC_CART_ID_CURRENT)) {
      this.multiCartFacade.loadCart({
        userId,
        cartId,
        extraData: {
          active: true,
        },
      });
    }
  }

  gonvarriAddEntry(
    productCode: string,
    quantity: number,
    numberOfSheets: number,
    packageWeight: number,
    isContract: boolean,
    pickupStore?: string,
    length?: number
  ): void {
    this.requireLoadedCart()
      .pipe(withLatestFrom(this.userIdService.getUserId()))
      .subscribe(([cart, userId]) => {
        this.multiCartFacade.gonvarriAddEntry(
          userId,
          getCartIdByUserId(cart, userId),
          productCode,
          quantity,
          numberOfSheets,
          packageWeight,
          isContract,
          pickupStore,
          length
        );
      });
  }

  updateEntryPackage(
    entryNumber: number,
    entryUnit: string,
    numberOfSheets: number,
    lenght: number,
    code: string,
    quantity: number,
    userId: string,
    cartId: string
  ): Observable<CartModification> {
    return this.cartEntryAdapter.updateEntryPackage(
      entryNumber,
      entryUnit,
      numberOfSheets,
      lenght,
      code,
      quantity,
      userId,
      cartId
    );
  }

  checkoutExpress(orderNumber: number, userId: string, cartId: string): Observable<any> {
    return this.cartEntryAdapter.checkoutExpress(orderNumber, userId, cartId);
  }

}
